import React from 'react'
import './PricingCard.css'

function PricingCard({ title, price, desc }) {
    return (
        <div className="pricingCard">
            <div className="pricing__info">
                <h3 className="pricing__title">{title}</h3>
                <p className="price">${price}</p>
                <p className="price__desc">{desc}</p>
                <ul>
                    <li>Graphic Design</li>
                    <li>Web Design</li>
                    <li>UI/UX</li>
                    <li>Html/Css</li>
                    <li>SEO Marketing</li>
                    <li>Business Improve</li>
                </ul>
            </div>
            <div className="pricing__button">
                chouse Plan
            </div>
        </div>
    )
}

export default PricingCard 
